import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Title = styled.div`
  font-size: 1.4rem;
  color: white;
  padding: 5px;
  width: 50%;

  input {
    background: transparent;
    font-size: 1.6rem;
    color: white;
    width: 100%;
    border: 0;
  }
`;

class TitleView extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    defaultTitle: PropTypes.string.isRequired,
    editable: PropTypes.bool,
  };

  static defaultProps = {
    editable: true,
  };

  onTitleInputClick = e => {
    const title = e.target.value.toUpperCase();
    if (title === this.props.defaultTitle) {
      e.target.select();
    }
  };

  render() {
    return (
      <Title>
        <input
          value={this.props.title}
          onChange={this.props.onChange}
          onClick={this.onTitleInputClick}
          disabled={!this.props.editable}
        />
      </Title>
    );
  }
}

export default TitleView;



// WEBPACK FOOTER //
// ./src/components/TitleView/TitleView.js